var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"no-body":""}},[_c('sale-by-range',{attrs:{"systemid":_vm.systemid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }